/**
 * User-facing message constants
 * 
 * Centralizes all UI messages for consistency and easier i18n support
 */

export const PERMISSION_MESSAGES = {
  LIMITED_ACCESS: "Limited access - basic fields only",
  LOADING: "Loading...",
} as const;
